<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

        <div style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden">
            <div style="padding: 2% 0; overflow: hidden">
                <div class="title">
                    订单生成成功，等待付款！
                </div>
                <div class="right_price">应付金额：￥{{ order_data.amount / 100 }}</div>
            </div>
            <div class="zhedieshangpin" @click="_zhedieshangpin">
                {{ zhedie_code ? '收起' : '展开' }}商品清单
                <a-icon :type="!zhedie_code ? 'down' : 'up'" style="color: #2b9a34" />
            </div>

            <div style="width: 98%; margin: 20px auto; overflow: hidden" v-if="zhedie_code" :key="index" v-for="(item, index) in order_data.list">
                <div style="display:flex;justify-content:space-between">
                    <div class="shop_name" style="display:flex">
                        <span style="width:200px">商家名称--{{ item.storeName }}</span>
                        <span style="width:200px">{{ item.warehouseName }}</span>
                        <span style="width:200px" v-if="getFreightType()">{{ getFreightType() }}</span>
                        <span class="ziying">{{ item.storeType == 'SELF' ? '自营' : '普通' }}</span>
                    </div>
                    <div>订单编号：{{ item.orderSn }}</div>
                </div>
                <div style="width: 100%; margin-top: 20px; border: 1px solid #ede9e9">
                    <div style="width: 100%; height: 40px; background: #ede9e9">
                        <div class="biaoge1">商品货号</div>
                        <div class="biaoge1">商品名称</div>
                        <div class="biaoge1">规格</div>
                        <div class="biaoge1">交期</div>
                        <div class="biaoge1">数量</div>
                        <div class="biaoge1">折扣价（元 ）</div>
                        <div class="biaoge1" style="width:12%">小计</div>
                        <div class="biaoge1">运费(不含首重)</div>
                        <div class="biaoge1">单品小计（元）</div>
                    </div>

                    <div style="width: 100%; height: 40px" v-for="(_item, index) in item.ordersItemList" :key="index">
                        <div>{{ isDanger(_item) }}</div>
                        <div class="biaoge1" style="color: #666; font-size: 12px; border-right: 1px solid #ede9e9">
                            {{ _item.skuSn }}
                        </div>
                        <div class="biaoge1 tiao" style="color: #666; font-size: 12px; border-right: 1px solid #ede9e9;color:rgb(43,154,52)" @click="tiao(_item)">
                            {{ _item.productName }}
                        </div>
                        <div class="biaoge1" style="color: #666; font-size: 12px; border-right: 1px solid #ede9e9">
                            {{ _item.specification || '-' }}
                        </div>
                        <div class="biaoge1" style="color: #666; font-size: 12px; border-right: 1px solid #ede9e9;">
                            {{ _item.quantity > 0 ? '现货' : '期货' }}
                        </div>
                        <div class="biaoge1" style="color: #666; font-size: 12px; border-right: 1px solid #ede9e9">x{{ _item.quantity }}</div>
                        <div class="biaoge1" style="color: #666; font-size: 12px; border-right: 1px solid #ede9e9">￥{{ _item.price / 100 }}</div>
                        <div class="biaoge1" style="color: #666; font-size: 12px; border-right: 1px solid #ede9e9">￥{{ (_item.price * _item.quantity) / 100 }}</div>
                        <div class="biaoge1" style="color: #f24145; font-size: 12px; border-right: 1px solid #ede9e9">
                            {{ _item.freight / 100 ? _item.freight / 100 : '0' }}
                        </div>
                        <div class="biaoge1" style="color: #f24145; font-size: 12px">￥{{ (_item.freight + _item.price * _item.quantity) / 100 }}</div>
                    </div>
                </div>

                <div class="actual_pay" style="margin-top: 20px">
                    应付金额：
                    <span style="font-weight: normal; font-size: 12px; color: #666">
                        <span style="color: #f24145;margin-right: 20px;font-weight: normal; font-size: 14px;"
                            ><strong>{{ item.orderAmount | moneyStr }}</strong></span
                        >
                        ({{ item.goods_count }}件商品，商品金额：
                        <span style="color: #f24145;margin-right: 20px;">{{ item.zongjia | moneyStr }}</span>
                        +运费(含首重)
                        <span style="color: #f24145;margin-right: 20px;">{{ item.freight | moneyStr }}</span>
                        -促销折扣
                        <span style="color: #f24145;margin-right: 20px;">{{ item.promotionDiscount | moneyStr }}</span>
                        -积分抵扣
                        <span style="color: #f24145">{{ item.pointOffsetAmount | moneyStr }}<span style="color:rgb(102, 102, 102);">)</span></span>
                    </span>
                </div>
                <div class="actual_pay" style="float: right; margin-top: 20px; font-weight: normal;">
                    已付款项：<span style="color: #f24145">{{ item.amountPaid | moneyStr }}</span>
                </div>
            </div>

            <div style="width: 100%; height: 20px"></div>
            <withGoods :storeId="storeId" :uuid="order_id" v-if="storeId" :orcContent="orcContent" />
            <div v-if="dangerText" style="font-size:16px;color:red;font-weight:700">尊敬的客户您好！您购买的订单包含特殊危化品，请首选线下支付，对公转账。</div>
            <div style="position: relative; width: 100%; border: 1px solid #ede9e9; margin-top: 20px; overflow: hidden">
                <div style="margin-top: 2%; overflow: hidden">
                    <div class="pay_type1" style="border-right: 1px solid #ede9e9">授信支付</div>
                    <div class="pay_type1" style="cursor: pointer;border-right: 1px solid #ede9e9" @click="payWeixin" v-if="show_modal_weixin">
                        <img src="../assets/wx2.png" style="width: 24px; height: 21px; float: left; margin-left: 50px; margin-top: 10px" alt="" />
                        <span style="float: left; margin-left: 10px">微信支付</span>
                    </div>
                    <div class="pay_type1" style="cursor: pointer;" @click="payZhifubao" v-if="show_modal_zfbpay">
                        <img src="../assets/zfb1.png" style="width: 24px; height: 21px; float: left; margin-left: 50px; margin-top: 10px" alt="" />
                        <span style="float: left; margin-left: 10px">支付宝支付</span>
                    </div>
                    <div class="pay_type1" style="cursor: pointer;border-left:1px solid #eee" v-if="xianshi === true">
                        <p style="width: 24px; height: 21px; float: left; margin-left: 20px; margin-top: 10px"></p>
                        <!-- <img style="width: 24px; height: 21px; float: left; margin-left: 50px; margin-top: 10px" alt="" /> -->
                        <span style="float: left; margin-left: 10px" @click="isXianxia">线下支付</span>
                    </div>
                    <div class="pay_type1" hidden>
                        <img src="../assets/yhk1.png" style="width: 24px; height: 21px; float: left; margin-left: 50px; margin-top: 10px" alt="" />
                        <span style="float: left; margin-left: 10px">银行卡支付</span>
                    </div>
                </div>

                <div style="margin-top: 20px; overflow: hidden" v-if="credit_search">
                    <div class="pay_type2" style="border-color: #2b9a34" v-if="credit_search.usable">
                        剩余可用额度
                        <span style="font-weight: bold; color: #2b9a34; font-size: 18px">￥{{ credit_search.amount / 100 }}</span>
                    </div>
                    <div class="pay_type2" style="color: #999" v-if="!credit_search.usable">
                        剩余可用额度
                        <span style="font-weight: bold; color: #999; font-size: 18px">￥{{ credit_search.amount / 100 }}</span>
                    </div>
                    <div style="color: #999" class="pay_type2">
                        已用额度
                        <span style="font-size: 18px">￥{{ credit_search.amountUsed / 100 }}</span>
                    </div>
                    <div style="color: #999" class="pay_type2">
                        总额度
                        <span style="font-size: 18px">￥{{ credit_search.creditAmount / 100 }}</span>
                    </div>
                </div>
                <div class="tips_txt" v-if="credit_search.amount / 100 <= 0">
                    *当前剩余可用额度不足以支付订单时，或授信额度失效时；请选择其他支付方式，或联系对应销售员、商城客服
                </div>
                <div style="overflow: hidden; margin-top: 2%; margin-left: 4%">
                    <div class="password_txt">请输入登录密码：</div>
                    <a-input placeholder="请输入登录密码" v-model="password" autocomplete="new-password" type="password" style="float: left; width: 400px; margin-left: 2%" />
                </div>

                <div @click="shouxinzhifu" class="pay_but" v-if="credit_search.amount / 100 >= 0">支付</div>
                <div class="pay_but" style="background:#999;" v-else>支付</div>
                <div style="width: 100%; height: 20px"></div>

                <!-- <div style="overflow: hidden; margin: 60px auto; width: 70%;  height: 800px;">
          <div style="float: left; width: 50%;">
            <div>
              <div class="zhifuerweima_txt">请使用 <span style="color: #2B9A34;">微信</span> 扫一扫 </div>
              <div class="zhifuerweima_txt" style="margin-top: 10px;">扫描二维码支付</div>
            </div>
            <div style="width: 300px;height: 336px;border: 1px solid #EDE9E9; margin: 20px auto; position: relative;">
              <img src="" style="width: 200px;height: 200px;background: #E8E6E6; margin: 20px auto; display: block;" alt="">
              <div style="width: 100%;height: 38px;background: #F7F7F7; position: absolute; bottom: 0;">
                <img src="../assets/laozhong1.png" style="width: 13px; height: 15px; float: left; margin-left: 20px; margin-top: 12px;" alt="">
                <span class="zhifutishi">二维码有效时长为2小时，请尽快支付</span>
              </div>
            </div>
          </div>
          <img src="../assets/zhifubangzhu.png" style="float: right; width: 329px; height: 421px;" alt="">
        </div> -->
                <!--  -->
                <div class="newModal" v-show="showTips">
                    <p class="tips-text2">请联系<span class="green" @click="showQQList = !showQQList">科隆客服</span>人员，完成电商用户平台建档。<br />或者去：个人中心-<span class="green" @click="To">授信建档</span>页面绑定已经完成建档的账号，共享权限资质和授信额度。</p>
                    <div class="QQ-list" v-show="showQQList">
                        <img src="../assets/trangle@2x.png" alt="" class="trangle" />
                        <div>点击下方QQ咨询客服</div>
                        <div class="QQ-item" v-for="item in QQlist" :key="item.uuid">
                            <a target="_blank" :href="`http://wpa.qq.com/msgrd?v=3&uin=${item.userQq}&site=qq&menu=yes`">
                                <img border="0" :src="`http://wpa.qq.com/pa?p=2:${item.userQq}:52`" alt="点击这里给我发消息" title="点击这里给我发消息" />
                                <div class="text">{{ item.userArea }}-{{ item.userId }}-{{ item.userQq }}</div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <foot />
        <a-modal class="modal-pay" title="微信扫码支付" :visible="show_modal_pay" :footer="null" :maskClosable="false" @cancel="show_modal_pay = false">
            <img :src="img_weixin_pay" />
        </a-modal>
        <a-modal v-if="xianxiazhanghao !== ''" title="线下支付确认信息" :visible="xianxiazhifu" :maskClosable="false" :footer="null" @cancel="xianxiazhifu = false">
            <!-- <p>{{xianxiazhanghao.name}}</p> -->
            <div style="text-align:center">
                <ul style="text-align:left;width:100%;">
                    <li>开户账号名称:&emsp;&emsp;{{ xianxiazhanghao.date1 }}</li>
                    <li>对公账号:&emsp;&emsp; &emsp;&emsp;{{ xianxiazhanghao.date2 }}</li>
                    <li>开户银行全称:&emsp;&emsp;{{ xianxiazhanghao.desc3 }}</li>
                </ul>
                <div class="okbtn">
                    <div class="quxiaobtn" @click="xianxiazhifu = false">取消支付</div>
                    <div class="surebtn" @click="queren">确认信息</div>
                </div>
                <!-- <div class="okbtn" style="float:right;margin:20px 0px 20px 160px" @click="queren">确认信息</div> -->
            </div>
            <p style="font-size: 12px;">注: 线下转账后，请点击已完成线下转账，等待后台收款，收款成功将为您安排发货</p>
        </a-modal>
        <!-- <a-modal title="温馨提示" :visible="showTips" :confirm-loading="confirmLoading" @ok="showTips = false" @cancel="showTips = false">
            <p class="tips-text">请联系<span class="green" @click="showQQList = !showQQList">科隆客服</span>人员，完成电商用户平台建档。<br />或者去：个人中心-<span class="green" @click="To">授信建档</span>页面绑定已经完成建档的账号，共享权限资质和授信额度。</p>
            <div class="QQ-list" v-show="showQQList">
                <img src="../assets/trangle@2x.png" alt="" class="trangle" />
                <div>点击下方QQ咨询客服</div>
                <div class="QQ-item" v-for="item in QQlist" :key="item.uuid">
                    <a target="_blank" :href="`http://wpa.qq.com/msgrd?v=3&uin=${item.userQq}&site=qq&menu=yes`">
                        <img border="0" :src="`http://wpa.qq.com/pa?p=2:${item.userQq}:52`" alt="点击这里给我发消息" title="点击这里给我发消息" />
                        <div class="text">{{ item.userArea }}-{{ item.userId }}-{{ item.userQq }}</div>
                    </a>
                </div>
            </div>
        </a-modal> -->
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
import withGoods from './withGoods.vue';
export default {
    name: 'integral',
    components: {
        userLeft,
        htmlHeader,
        foot,
        withGoods
    },
    data() {
        return {
            dangerText: false,
            order_id: '',
            payOrderId: '',
            order_data: [], //订单数据
            orderSn: [], // 订单编号
            zhedie_code: true, //是否展示订单
            credit_search: '', //可用授信查询
            password: '', //密码
            show_modal_pay: false,
            show_modal_weixin: false,
            img_weixin_pay: '',
            show_modal_zfbpay: false,
            form: '',
            storeId: '',
            xianshi: false,
            xianxiazhifu: false,
            xianxiazhanghao: '',
            message: '',
            orcContent: {},
            QQlist: [],
            showQQList: false,
            showTips: false
        };
    },
    filters: {
        moneyStr(value) {
            value = value ? value / 100 : 0;
            return '￥' + value.toFixed(2);
        }
    },
    methods: {
        isDanger(item) {
            // return '666';
            console.log(item, 'caoccccc');
            if (item.riskNature == '易制爆化学品' || item.riskNature == '易制爆化学品') {
                this.dangerText = true;
            }
        },
        getFreightType() {
            // debugger;
            if (this.order_data && this.order_data.list && this.order_data.list.length > 0 && this.order_data.list[0].freightType) {
                let index = this.order_data.list[0].freightType;
                let freightTypeLst = {
                    customerSelfDelivery: '客户自提',
                    roadTransportNormal: '科隆送货（正常送）',
                    roadTransportLimit: '科隆送货（限时达）',
                    expressDelivery: '快递配送',
                    homeDelivery: '公路托运（送货上门）',
                    siteSelfDelivery: '公路托运（站点自提）',
                    logistics: '物流到付',
                    expressArrival: '快递到付'
                };
                console.log(index, '哒哒哒哒哒哒付啥付多啥');
                return freightTypeLst[index];
            } else {
                return '';
            }
        },
        getQQlist() {
            this.api
                .getQQListAll()
                .then(result => {
                    this.QQlist = result.data;
                })
                .catch(err => {});
        },
        /**获取是否拥有购买资格*/
        get_qualification() {
            let uuids = this.$route.query.uuid.split(',');
            this.api.get_qualification({ list: uuids }).then(res => {
                //  console.log(res.message,'我在这儿');
                if (!res.data) {
                    this.message = res.message;
                    this.message == '' ? (this.showTips = false) : (this.showTips = true);
                }
            });
        },
        isXianxia() {
            if (this.message == '') {
                this.api.isHaveK3(this.order_id).then(res => {
                    if (res.ok) {
                        this.xianxiazhifu = true;
                    } else {
                        this.$message.error(res.message);
                    }
                });
            } else {
                // this.$message.error(this.message);//TODO
                this.showTips = true;
            }
        },
        queren() {
            const list = [];
            list.push(this.order_id);
            const id = {
                list: list
            };
            this.api.xianxiazhifu(id).then(res => {
                console.log(res.data);
                if (res.ok === true) {
                    this.$router.push('/order');
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        tiao(e) {
            this.$router.push(`/goods_details?uuid=${e.productId}&storeId=${e.storeId}`);
        },
        To() {
            this.$router.push(`/credit_y`);
        },
        checkPaid() {
            if (!this.show_modal_pay) return;
            this.api.ordersCheckPaid(this.payOrderId).then(res => {
                console.log(res);
                if (res.data) {
                    this.$router.push(`/pay_successful?uuid=${this.order_id}&pid=${this.payOrderId}`);
                } else {
                    setTimeout(() => this.checkPaid(), 1500);
                }
            });
        },
        zhifubao() {
            this.api.ZfbpayPaid(this.payOrderId).then(res => {
                console.log(res);
                if (res.data) {
                    this.$router.push(`/pay_successful?uuid=${this.order_id}&pid=${this.payOrderId}`);
                } else {
                    if (this.$route.path == '/credit_pay') {
                        setTimeout(() => this.zhifubao(), 1500);
                    }
                }
            });
        },
        payZhifubao() {
            if (this.message == '') {
                const url = `${window.location.origin}/#/pay_successful?uuid=${this.order_id}`;
                // const url = `https://www.cdkelong.com?uuid=${this.order_id}/#/`;
                console.log(url);
                this.api.ordersZfbpay({ batchModel: this.order_id, returnUrl: url }).then(res => {
                    if (res.ok) {
                        console.log(res.data);
                        this.payOrderId = res.data.payOrderId;
                        // let routerData = this.$router.resolve({path:'/zhifubao',query:{htmls:res.data.form}});
                        // window.open(routerData.href,'_blank');
                        const div = document.createElement('div');
                        div.innerHTML = res.data.form;
                        document.body.appendChild(div);
                        document.forms[0].submit();
                        this.zhifubao();
                    } else {
                        this.$message.error(res.message);
                    }
                });
            } else {
                // this.$message.error(this.message);
                this.showTips = true;
            }
        },
        payWeixin() {
            if (this.message == '') {
                this.api.ordersWxpay(this.order_id).then(res => {
                    if (res.ok) {
                        console.log(res);
                        this.show_modal_pay = true;
                        this.payOrderId = res.data.payOrderId;
                        this.img_weixin_pay = 'data:image/png;base64,' + res.data.qrcodeBase64;
                        this.checkPaid();
                    } else {
                        this.$message.error(res.message);
                    }
                });
            } else {
                // this.$message.error(this.message);
                this.showTips = true;
            }
        },
        // 授信支付
        shouxinzhifu() {
            if (this.message == '') {
                if (this.password == '') {
                    this.$message.error('请输入登录密码');
                    return false;
                }
                let obj = {
                    orderIds: [],
                    password: this.password
                };
                this.order_data.list.forEach(element => {
                    obj.orderIds.push(element.uuid);
                    element.ordersItemList.forEach(e2 => {
                        // obj.orderIds.push(e2.uuid)
                    });
                });
                this.api.creditExtension(obj).then(res => {
                    if (res.ok) {
                        const data = res.data;
                        this.$message.success(res.message);
                        this.$router.push(`/pay_successful?uuid=${data.targetIds[0]}&pid=${data.uuid}`);
                    } else {
                        console.log(res);
                        this.$message.error(res.message);
                    }
                });
            } else {
                // this.$message.error(this.message);
                this.showTips = true;
            }
        },
        // 前台授信查询
        get_credit_search() {
            this.api
                .get_credit_search({
                    storeId: this.order_data.list[0].storeId
                })
                .then(res => {
                    console.log(res);
                    if (res.data) {
                        if (res.data.amount == null) {
                            res.data.amount = 0;
                        }
                        if (res.data.usable == false) {
                            this.$message.error('授信不可用（不在有效期）');
                        }
                        this.credit_search = res.data;
                    }
                });
        },
        // 折叠商品列表
        _zhedieshangpin() {
            this.zhedie_code = !this.zhedie_code;
        },
        // 初始数据
        get_order_batchDetail() {
            let uuids = this.$route.query.uuid.split(',');
            this.order_id = uuids[0];
            this.api.get_order_batchDetail({ list: uuids }).then(res => {
                if (res.ok) {
                    let orderSn = [];
                    this.order_data = res.data;
                    this.storeId = res.data.list[0].storeId;
                    // debugger;
                    this.orcContent = JSON.parse(res.data.list[0].orcContent);
                    console.log(this.orcContent);
                    this.api.get_xinaxia(this.storeId).then(res => {
                        if (res.data.name !== '') {
                            this.xianshi = true;
                            this.xianxiazhanghao = res.data;
                        } else {
                            this.xianshi = false;
                        }
                    });
                    // 计算总价
                    res.data.list.forEach(element => {
                        orderSn.push(element.orderSn);
                        element.zongjia = 0; //每单总价
                        element.goods_count = 0; //每单商品数量
                        element.ordersItemList.forEach(e2 => {
                            element.zongjia += e2.price * e2.quantity;
                            element.goods_count += e2.quantity;
                        });
                    });
                    this.orderSn = orderSn.join(',');
                    if (res.data.list[0]) {
                        this.get_credit_search();
                        this.set_zhifubao();
                        this.set_weixin();
                    } else {
                        this.$message.error('缺少list数据!');
                    }
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 判断是否支持支付宝
        set_zhifubao() {
            this.api.zhifubao(this.storeId).then(res => {
                if (res.data) {
                    this.show_modal_zfbpay = true;
                }
            });
        },
        // 是否支持微信
        set_weixin() {
            this.api.weixin(this.storeId).then(res => {
                if (res.data) {
                    this.show_modal_weixin = true;
                }
            });
        }
    },
    created() {
        this.get_order_batchDetail();
        this.get_qualification();
        this.getQQlist();
    }
};
</script>

<style scoped>
ul li {
    margin: 15px 0;
    list-style-type: none;
}

/deep/ .ant-modal-content {
    margin-top: 150px;
}

.modal-pay img {
    display: block;
    margin: 0 auto;
    width: 300px;
    height: 300px;
}

.tiao:hover {
    cursor: pointer;
}

.zhedieshangpin {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    cursor: pointer;
}

.biaoge1 {
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    float: left;
    width: 11%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0 10px;
}

.zhifutishi {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    line-height: 28px;
    float: left;
    margin-left: 20px;
    margin-top: 5px;
}

.zhifuerweima_txt {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    text-align: center;
}

.pay_but {
    width: 120px;
    height: 48px;
    background: #2b9a34;
    text-align: center;
    line-height: 48px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    float: right;
    margin-right: 4%;
    margin-top: 2%;
    margin-bottom: 20px;
    cursor: pointer;
}

.okbtn {
    width: 472px;
    height: 40px;
    padding: 0 40px;
    /* background: #2b9a34; */

    margin-bottom: 20px;
}

.surebtn {
    float: right;
    width: 120px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
    background: #2b9a34;
}

.quxiaobtn {
    box-sizing: border-box;
    text-align: center;
    line-height: 36px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: red;
    cursor: pointer;
    margin-left: 20px;
    float: right;
    width: 120px;
    height: 40px;
    border: 3px solid red;
}

.password_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    float: left;
}

.tips_txt {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-top: 2%;
    margin-left: 4%;
}

.pay_type2 {
    /* width: 200px; */
    padding: 0 20px;
    height: 40px;
    border: 1px solid #ede9e9;
    float: left;
    text-align: center;
    line-height: 40px;
    color: #666666;
    margin-left: 4%;

    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    font-size: 14px;
}

.pay_type1 {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    text-align: center;
    line-height: 40px;
    height: 40px;
    width: 200px;
    float: left;
}

.actual_pay {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    float: left;
}

.ziying {
    width: 32px;
    height: 20px;
    background: #2b9a34;
    text-align: center;
    line-height: 20px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    float: left;
    margin-left: 4%;
}

.shop_name {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}

.goods_list {
}

.right_price {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #f24145;
    float: right;
}

.title {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    float: left;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}

.green {
    color: #2b9a34;
    cursor: pointer;
}

/deep/.ant-modal-body {
    position: relative;
}

.newModal {
    position: absolute;
    width: 1200px;
    height: 315px;
    top: 0;
    left: 0;
    background: #eaeaea;
}

.tips-text {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
}

.tips-text2 {
    margin-top: 120px;
    width: 1200px;
    text-align: center;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
}

.ant-modal-body {
    position: relative;
}

.QQ-list {
    position: absolute;
    top: 15px;
    left: 880px;
    width: 248px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px #e6e6e6;
    padding: 10px;
    margin-left: 18px;
    /* position: relative; */

    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 16px;
}

.trangle {
    width: 8px;
    height: 16px;
    position: absolute;
    left: -8px;
}

.text {
    white-space: nowrap;
    /* 规定文本是否折行 */
    overflow: hidden;
    /* 规定超出内容宽度的元素隐藏 */
    text-overflow: ellipsis;
    margin-left: 10px;
    line-height: 25px;
}

a {
    display: flex;
    color: #333333;

    &:hover {
        color: #2b9a34;
    }
}

.QQ-item {
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/credit_pay.vue